// extracted by mini-css-extract-plugin
export default {"pageLayout":"DoOUb_Ij","content":"U6AXZ3uZ","sidebar":"RC7owmRF","_left":"cE0FB5sh","_right":"qsiQRbN6"};